import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const studygroupsubjectSlice = createSlice({
  name: "studygroupsubject",
  initialState,
  // reducers: {},
});

// export const { userLoggedIn, userLoggedOut } = userSlice.actions
export default studygroupsubjectSlice.reducer;
